import { Controller } from "stimulus"

// #1621: "Trainer mag zien" kan alleen aan bij een type dat ook wordt
// ingelezen. Zet de sporter inlezen uit, dan gaat delen mee uit.
export default class extends Controller {
  static targets = ["toestaan", "delen"]

  wissel(event) {
    const type = event.target.closest("[data-datatype]")
    if (!type) return

    const delen = type.querySelector("[data-gezondheid-toestemming-target='delen']")
    if (!delen) return

    delen.disabled = !event.target.checked
    if (!event.target.checked) delen.checked = false
  }
}
